import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { categorySourceReducer } from "./categorySourceReducer";
import { commonReducer } from "./commonReducer";
import { dictionaryReducer } from "./dictionaryReducer";
import { localizedResourceReducer } from './localized-resource/localizedResourceReducer';
import { notifyReducer } from './notify/notifyReducer';
import { uploadReducer } from './upload-file/uploadReducer';
import { appConfigReducer } from "./common/appConfigReducer";
import { danhMucReducerWrapper } from "./danh-muc/danhMucReducerWrapper";
import { thoiKhoaBieuReducerWrapper } from "./thoi-khoa-bieu/thoiKhoaBieuReducerWrapper";
import { diemDanhReducer } from "./diem-danh/diemDanhReducer";
const reducers = combineReducers({
    auth: authReducer,
    appConfig: appConfigReducer,
    dictionary: dictionaryReducer,
    categorySource: categorySourceReducer,
    common: commonReducer,
    uploadFile: uploadReducer,
    notify: notifyReducer,
    localizedResource: localizedResourceReducer,
    danhMucWrapper: danhMucReducerWrapper,
   thoiKhoaBieuWrapper: thoiKhoaBieuReducerWrapper,
   diemDanh: diemDanhReducer,
})

export default reducers

export type RootState = ReturnType<typeof reducers>